import { Endpoints } from "../lib/endpoints";
import { PerformRequest } from "../lib/usePerformRequest";
import { NonPaginatedResponse } from "../lib/types";

export interface UploadImageResponse {
  url: string;
  publicId: string;
  width: number;
  height: number;
  format: string;
}

export async function uploadImage(
  file: File,
  folder?: string
): Promise<UploadImageResponse> {
  const formData = new FormData();
  formData.append("image", file);
  if (folder) {
    formData.append("folder", folder);
  }

  const result = await PerformRequest<NonPaginatedResponse<UploadImageResponse>>(
    {
      method: "POST",
      route: Endpoints.UploadImage().route,
      data: formData,
      headers: {},
    }
  );

  if (result.status === 200) {
    return result.data.data;
  }
  throw new Error(result.message || "Failed to upload image");
}
